var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEmail01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1269_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    d: "M33.3,5.9H2.7c-1.2,0-2.2,1-2.2,2.2v1.2L18,16.8l17.5-7.4V8.1C35.5,6.9,34.6,5.9,33.3,5.9 C33.3,5.9,33.3,5.9,33.3,5.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1272",
    transform: "translate(0 3.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    d: "M18.4,15.7c-0.3,0.1-0.6,0.1-0.9,0L0.5,8.4v16.1c0,1.2,1,2.2,2.2,2.2h30.7c1.2,0,2.2-1,2.2-2.2V8.4 L18.4,15.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmail01);
export default __webpack_public_path__ + "static/media/ico-email-01.0bcc7eb0855672074868cec3a0621286.svg";
export { ForwardRef as ReactComponent };